import React from "react";
import addGift from "../../svg/addGift.svg";
import leagueIcon from "../../svg/leagueIcon.svg";
import chartIcon from "../../svg/chartIcon.svg";
import massageIcon from "../../svg/massageIcon.svg";
import lotteryIcon from "../../svg/lotteryIcon.svg";
import serviceIcon from "../../svg/serviceIcon.svg";
import simCardIcon from "../../svg/simCardIcon.svg";
import elevatorIcon from "../../svg/elevatorIcon.svg";
import usersIcon from "../../svg/usersIcon.svg";
import { GroupIconSvg } from "../../svg/GroupIconSvg";
import { leagueSvg } from "../../svg/league.svg";
import { URLs } from "../urls";

export const menu = {
  sidebar: [
    {
      label: "فهرست کاربرها",
      key: "users",
      url: URLs.USERS,
      icon: <img src={usersIcon} width={22} />,
    },
    {
      label: " تیکت ",
      key: "tiket",
      url: URLs.TIKET,
      icon: <img src={massageIcon} width={22} />,
    },
    {
      label: "نصب شده ها",
      key: "install",
      url: URLs.INSTALL,
      icon: <img src={elevatorIcon} width={22} />,
    },
    {
      label: "برترین ها",
      key: "topUsers",
      url: URLs.TOPUSERS,
      icon: leagueSvg({ width: "23px", height: "23px", fill: "#000" }),
    },

    {
      label: " تنظیمات خانه ستارگان ",
      key: "service",
      url: URLs.SERVICES,
      icon: <img src={serviceIcon} width={20} />,
    },
    {
      label: "کدها  ",
      key: "code",
      url: URLs.CODE,
      icon: <img src={lotteryIcon} width={24} />,
    },
    // {
    //   label: "فهرست برنده ها",
    //   key: "lottery",
    //   url: URLs.LOTTERY,
    // },
    // {
    //   label: "جایزه دوره ها",
    //   key: "reward",
    //   url: URLs.REWARD,
    // },
    {
      label: "سفارشات",
      key: "campaign",
      url: URLs.CAMPAIGN,
      icon: <GroupIconSvg width={20} height={20} />,
    },
    // {
    //   label: "پیام ها",
    //   key: "message",
    //   url: URLs.MESSAGE,
    //   icon: <img src={massageIcon} width={22} />,
    // },
    {
      label: "گزارش‌ ها",
      key: "report",
      url: URLs.CHART,
      icon: <img src={chartIcon} width={22} />,
    },
    // {
    //     label: 'افزودن سوال',
    //     key: 'question',
    //     url: URLs.ADD_QUESTION,
    // },

    {
      label: "افزودن هدیه",
      key: "AddGift",
      url: URLs.AddGift,
      icon: <img src={addGift} />,
    },
  ],
};

export const CONSTANTS = {
  SUCCESS_MESSAGE: "عملیات با موفقیت انجام شد",
  ERROR_MESSAGE: "عملیات با مشکل مواجه شد!",
};
